import { datadogRum } from 'embed/services/Datadog/RUM'
import { RUMErrorKeys } from 'embed/services/Datadog/RUM/constants'
import { lazyLoadScript } from 'embed/utils'

export const TRUSTPILOT_SCRIPT_ID = 'trustpilot-iframe-helper'
const TRUSTPILOT_SCRIPT_SRC = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'

export interface Trustpilot {
  loadFromElement: (element: Element, forceReload: boolean) => void
}

export const isBrowser = (): boolean => typeof window !== 'undefined'

export const lazyInitTrustpilotWidget = (element: HTMLElement) => {
  if (element && isBrowser() && window.Trustpilot) {
    try {
      window.Trustpilot.loadFromElement(element, false)
    } catch (err) {
      if (!(err instanceof Error)) {
        err = new Error('Error Loading From Element')
      }
      datadogRum.addAction(RUMErrorKeys.TRUSTPILOT_LOAD_ERROR, err)
    }
  } else {
    // If the script hasnt loaded yet (window.Trustpilot is null) then we can just let the script init the widgets, no callback needed
    loadTrustpilotHelperScript().catch((error) => {
      datadogRum.addAction(RUMErrorKeys.TRUSTPILOT_LOAD_ERROR, error)
    })
  }
}

export const loadTrustpilotHelperScript = () => lazyLoadScript(TRUSTPILOT_SCRIPT_ID, TRUSTPILOT_SCRIPT_SRC)
